import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { PageHomeComponent } from './components/page-home/page-home.component';
import { PageInternetComponent } from './components/network/page-internet/page-internet.component';
import { PageWhteNasComponent } from './components/network/page-whte-nas/page-whte-nas.component';
import { PageNasComponent } from './components/network/page-nas/page-nas.component';
import { PageUsenasComponent } from './components/network/page-usenas/page-usenas.component';
import { PageInternetLANComponent } from './components/network/page-internet-lan/page-internet-lan.component';
import { PageInternetWifiComponent } from './components/network/page-internet-wifi/page-internet-wifi.component';
import { PageUpdatewindowsComponent } from './components/network/page-updatewindows/page-updatewindows.component';
import { PageComputerproblemComponent } from './components/network/page-computerproblem/page-computerproblem.component';
import { PageFilegoogleComponent } from './components/network/page-filegoogle/page-filegoogle.component';
import { ComslowComponent } from './components/network/comslow/comslow.component';
import { PageDrivemaxComponent } from './components/network/page-drivemax/page-drivemax.component';
import { UsefileComponent } from './components/network/usefile/usefile.component';
import { PagePrinterComponent } from './components/network/page-printer/page-printer.component';
import { PagePrintInternetComponent } from './components/network/page-print-internet/page-print-internet.component';
import { PagePrinterDriverComponent } from './components/network/page-printer-driver/page-printer-driver.component';
import { PageDataComponent } from './components/network/page-data/page-data.component';
import { PageDataonedriveComponent } from './components/network/page-dataonedrive/page-dataonedrive.component';
import { PageDatagoogleComponent } from './components/network/page-datagoogle/page-datagoogle.component';
import { PageCalendarComponent } from './components/network/page-calendar/page-calendar.component';
import { DriverMacComponent } from './components/network/driver-mac/driver-mac.component';
import { MonitorMacComponent } from './components/network/monitor-mac/monitor-mac.component';
import { NasMacComponent } from './components/network/nas-mac/nas-mac.component';

@NgModule({
  declarations: [
    AppComponent,
    PageHomeComponent,
    PageInternetComponent,
    PageWhteNasComponent,
    PageNasComponent,
    PageUsenasComponent,
    PageInternetLANComponent,
    PageInternetWifiComponent,
    PageUpdatewindowsComponent,
    PageComputerproblemComponent,
    PageFilegoogleComponent,
    ComslowComponent,
    PageDrivemaxComponent,
    UsefileComponent,
    PagePrinterComponent,
    PagePrintInternetComponent,
    PagePrinterDriverComponent,
    PageDataComponent,
    PageDataonedriveComponent,
    PageDatagoogleComponent,
    PageCalendarComponent,
    DriverMacComponent,
    MonitorMacComponent,
    NasMacComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
